import styled from "styled-components";

export const BalanceCard = styled.div`
  width: 100%;
  display: flex;
  align-items: baseline;
  justify-content: center;
  background-color: ${({ theme }) => theme.booksBg};
  color: ${({ theme }) => theme.black50};
  font-size: 18px;
  font-weight: 700;
  padding: 30px 0;
  text-align: center;
`;

export const BalanceValue = styled.span`
  margin-left: 4px;
  color: ${({ theme }) => theme.black};
  font-size: 24px;
`;
